export const referrerExists = () => {
  return (traffic) => {
    return traffic.referrer !== '';
  };
};
